import React, { useState, useEffect } from 'react';
import EfiraImage from '../assets/efira.svg';
import TrackingImage from '../assets/tracking.svg';
import CurrenciesImage from '../assets/3.svg';

const BenefitsSection: React.FC = () => {
  const defaultUTM =
  "?utm_source=online&utm_medium=website&utm_campaign=website_lead&utm_term=landing_page";

const [utmParams, setUtmParams] = useState<string>(() => {
  // Try to get from localStorage on initial load (e.g. second visit)
  return localStorage.getItem('utm_params') || defaultUTM;
});

useEffect(() => {
  const queryString = window.location.search;
  if (queryString && queryString.includes('utm_')) {
    localStorage.setItem('utm_params', queryString);
    setUtmParams(queryString); // Triggers rerender
  }
}, []);

const signupLink = `https://app.eximpe.com/auth/sign-up${utmParams}`;



  return (
    <section id="benefits" className="py-20 bg-gradient-to-b from-white to-gray-50 lg:px-[13%] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-1/4 left-0 w-full h-64 -skew-y-6 bg-[#ecf6f3]/50 -z-10"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 rounded-full bg-[#1c9e86]/5 -z-10"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 rounded-full bg-[#1c9e86]/5 -z-10"></div>

      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="inline-block px-4 py-1 rounded-full bg-[#ecf6f3] text-[#1c9e86] font-medium text-sm mb-4">
            Premium Features
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-6">
            Why Choose Our Services
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Discover how our global account services make international banking easier, faster, and more cost-effective.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Box 1 */}
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 flex flex-col items-center text-center transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
            <div className="mb-6 w-full h-48 sm:h-56 flex items-center justify-center rounded-lg overflow-hidden bg-[#ecf6f3]">
              <img src={EfiraImage} alt="E-FIRA" className="w-full h-full object-contain p-4 transition-transform hover:scale-105 duration-300" />
            </div>
            <div className="p-3 bg-[#ecf6f3] rounded-full mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1c9e86] rounded-full text-white font-bold text-xl">1</div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">E-FIRA</h3>
            <p className="text-gray-600 mb-6">
              Our electronic financial interface for rapid approval streamlines your international banking experience, making it faster and more efficient.
            </p>
          </div>

          {/* Box 2 */}
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 flex flex-col items-center text-center transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
            <div className="mb-6 w-full h-48 sm:h-56 flex items-center justify-center rounded-lg overflow-hidden bg-[#ecf6f3]">
              <img src={TrackingImage} alt="Real Time FX Tracking" className="w-full h-full object-contain p-4 transition-transform hover:scale-105 duration-300" />
            </div>
            <div className="p-3 bg-[#ecf6f3] rounded-full mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1c9e86] rounded-full text-white font-bold text-xl">2</div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">Real Time FX Tracking</h3>
            <p className="text-gray-600 mb-6">
              Monitor exchange rates in real-time and get alerts when rates are favorable. Never miss an opportunity to save on your international transfers.
            </p>
          </div>

          {/* Box 3 */}
          <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 flex flex-col items-center text-center transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
            <div className="mb-6 w-full h-48 sm:h-56 flex items-center justify-center rounded-lg overflow-hidden bg-[#ecf6f3]">
              <img src={CurrenciesImage} alt="Supports Over 100+ Currencies" className="w-full h-full object-contain p-4 transition-transform hover:scale-105 duration-300" />
            </div>
            <div className="p-3 bg-[#ecf6f3] rounded-full mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1c9e86] rounded-full text-white font-bold text-xl">3</div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">100+ Currencies</h3>
            <p className="text-gray-600 mb-6">
              Send and receive money in more than 100 currencies worldwide. Our global reach ensures you can conduct business anywhere.
            </p>
          </div>
        </div>

        {/* Sign Up Button */}
        <div className="mt-16 text-center">
          <a href={signupLink}>
            <button className="inline-block bg-[#1c9e86] hover:cursor-pointer hover:bg-[#168a75] text-white font-bold py-4 px-8 sm:px-12 rounded-lg transition duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 text-lg">
              Sign Up Now
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
